import script from "./BasePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePopup.vue?vue&type=script&setup=true&lang=ts"

import "./BasePopup.vue?vue&type=style&index=0&id=73720502&lang=scss"

const __exports__ = script;

export default __exports__